import React from 'react';
import Panel from './Panel';
import Itens from '../../components/Panel/Inclusao/ItensMenu';


const SelectInclusao = () => {

    return (
        <Panel>
            <div>
                <Itens />
            </div>
        </Panel>

    );
};

export default SelectInclusao;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/SelectInclusao.js
 **/